export default {
  en: {

    currencyFormat: {
      style: "currency",
      notation: 'standard',
      currency: "USD",
      decimal: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      percent: {
        style: 'percent', useGrouping: false
      }
    }
    
  },
  it: {

    currencyFormat: {
      style: "currency",
      notation: 'standard',
      currency: "EUR",
      decimal: {
        style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
      },
      percent: {
        style: 'percent', useGrouping: false
      }
    }

  },
}